import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { Thermometer, Wine, Brain, Droplets, Monitor } from 'lucide-react';
export function RevealSection() {
  const triggers = [{
    icon: Thermometer,
    text: 'temperatura / sofocos'
  }, {
    icon: Wine,
    text: 'azúcar, alcohol o cena tarde'
  }, {
    icon: Brain,
    text: 'estrés y rumiación'
  }, {
    icon: Droplets,
    text: 'baño/vejiga'
  }, {
    icon: Monitor,
    text: 'ambiente (luz, ruido, pantallas)'
  }];
  return <section className="py-24 px-4 relative overflow-hidden" data-id="element-137">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-138">
        <SectionWrapper data-id="element-139">
          <div className="mb-16" data-id="element-140">
            <span className="text-[var(--accent-teal)] font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-141">
              La Revelación
            </span>
            <h2 className="text-3xl md:text-5xl text-[var(--text-primary)] mb-6" data-id="element-142">
              No es "insomnio". <br data-id="element-143" />
              <span className="text-[var(--accent-teal)]" data-id="element-144">Es un patrón.</span>
            </h2>
            <p className="text-lg text-[var(--text-secondary)]" data-id="element-145">
              En este sistema vas a identificar tu combinación real de
              disparadores con el Mapa 3AM:
            </p>
          </div>
        </SectionWrapper>

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 mb-12" data-id="element-146">
          {triggers.map((trigger, index) => <SectionWrapper key={index} delay={0.1 + index * 0.1} data-id="element-147">
              <div className="bg-[var(--bg-card)] p-6 rounded-xl border border-[var(--bg-card-hover)] hover:border-[var(--accent-teal-dim)] transition-colors group h-full" data-id="element-148">
                <div className="flex items-start justify-between mb-4" data-id="element-149">
                  <span className="text-4xl font-serif text-[var(--bg-card-hover)] group-hover:text-[var(--accent-teal-dim)] transition-colors" data-id="element-150">
                    {index + 1}
                  </span>
                  <trigger.icon className="w-6 h-6 text-[var(--accent-teal)]" data-id="element-151" />
                </div>
                <p className="text-lg font-medium text-[var(--text-primary)]" data-id="element-152">
                  {trigger.text}
                </p>
              </div>
            </SectionWrapper>)}
        </div>

        <SectionWrapper delay={0.6} data-id="element-153">
          <p className="text-center text-xl md:text-2xl font-serif italic text-[var(--text-secondary)]" data-id="element-154">
            No para obsesionarte. <br data-id="element-155" />
            <span className="text-[var(--text-primary)]" data-id="element-156">
              Para dejar de adivinar.
            </span>
          </p>
        </SectionWrapper>
      </div>
    </section>;
}